// env.staging.ts
export const stagingEnv = {
  VITE_ENV: 'staging',
  VITE_AZURE_ENV: 'test',

  VITE_PLATFORM_REST_ENDPOINT: 'https://portal-api.test.artbasel.app/api-test',
  VITE_X_API_KEY: 'portal_api_test_1c432dd045af6a3209703dde00811171',
  VITE_SERVER_EVENTS_PREFIX: 'https://portal-api.test.artbasel.app/api-test',

  VITE_AUTH_TOKEN_KEY: 'auth-token-staging',
  VITE_AUTH0_CLAIMS_NAMESPACE: 'https://arcual-access.com',
  VITE_AUTH0_CLAIMS_NAMESPACE_MCH: 'https://mch-aim-dev',

  VITE_STOREFRONT_URL: 'test.artbasel.app',
  VITE_PLATFORM_URL: 'https://portal.test.artbasel.app',

  VITE_IMG_PROXY_URL: 'https://cdn.staging.arcual.art',
  VITE_PROFILE_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-staging',
  VITE_ARTWORK_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-pictures-staging',
  VITE_DOCUMENTS_IMG_PROXY_BUCKET: 's3://arcual-access-artwork-documents-staging',

  VITE_SENTRY_INGEST_URL:
    'https://8aa8ff085fbcbcf4a7cbd1ad03bc07f9@o4510986579607552.ingest.de.sentry.io/4510997902458960',

  // Feature flags (TODO: make server side)
  VITE_FEATURE_EDITIONS_ENABLED: true,
  VITE_FEATURE_DASHBOARD_ANALYTICS_ENABLED: true,

  VITE_FEATURE_SENTRY_ENABLED: true,
  VITE_FEATURE_SENTRY_CUSTOMER_FEEDBACK_ENABLED: true,

  // TODO remove once price visibility selection is implemented
  VITE_FEATURE_HIDE_PRICE_VISIBILITY_ID: 'f31ed19e-0d6a-4581-bc00-15a15e10f589',

  VITE_FUTURE_FAIR_ACTIVATION_ID: 'cf9965ef-4d0b-4f8c-9031-556d48080050',
  VITE_FUTURE_FAIR_ACTIVATION_ID_2: '7ae1b8c3-28f9-4ab0-b0e1-69c174738711',

  // checkout application
  VITE_CHECKOUT_DOMAIN: 'https://checkout.staging.arcual.app/',
  // TODO: replace with server side request to get the images
  // CORS image request proxy service
  VITE_CORS_PROXY: 'https://ptk2a9accc.execute-api.eu-central-1.amazonaws.com/staging/cors-proxy?url=',
  VITE_AMPLITUDE_CLIENT_KEY: 'client-Nai5u2Bku3NZkMWq1KULYzUIgjttFgHs',
  VITE_USETIFUL_TOKEN: null,

  // Analytics
  VITE_GOOGLE_TAG_MANAGER_ID: 'G-7WXYB8LNB3',
  VITE_CLARITY_PROJECT_ID: 'wq02701f6d',
};
